module.exports = __webpack_public_path__ + "img/sterren.17770f59843823101022f15238076b55.svg";